import { render, staticRenderFns } from "./ModalDeleteConfirm.vue?vue&type=template&id=354c71f9&scoped=true&"
import script from "./ModalDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c71f9",
  null
  
)

export default component.exports